export default __webpack_public_path__ + "img/d08bd84d6fbca08b943faa0f321e5f99.png";